const Dynamic_Course_Exam = () => {
  return (
    <div>
      <h1>Dynamic Course Exam</h1>
    </div>
  );
};
export default Dynamic_Course_Exam;
